import { id } from '@swimlane/ngx-charts';
import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { DeletePopupComponent } from "../delete-popup/delete-popup.component";
import { HttpService } from "src/app/services/http/http.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from '@angular/router'
import { TooltipPosition } from '@angular/material/tooltip';
import { FormControl } from "@angular/forms";
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: "app-restaurantlists",
  templateUrl: "./restaurantlists.component.html",
  styleUrls: ["./restaurantlists.component.scss"],
})
export class RestaurantlistsComponent implements OnInit {
  restaurantList: any[] = [];
  masterRestaurantList: any[] = [];
  displayedColumns: string[] = [
    "id",
    "name",
    "info",
    "status",
    // "email",
    "view",
  ];
  masterDisplayedColumns: string[] = [
    "id",
    "name",
    "email",
    "edit",
  ];

  dataSource: MatTableDataSource<[]> = new MatTableDataSource(
    this.restaurantList
  );

  masterRestodataSource: MatTableDataSource<[]> = new MatTableDataSource(
    this.restaurantList
  );

  constructor(
    public dialog: MatDialog,
    private httpSv: HttpService,
    private _snackBar: MatSnackBar,
    private router: Router
  ) { }
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatPaginator) paginator1: MatPaginator;

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.masterRestodataSource.paginator = this.paginator1;
  }
  ngOnInit(): void {
    this.selectAllForDropdownItems(this.getAllergens())
    this.selectAllForDropdownItems(this.getData());
    this.selectAllForDropdownItems(this.getCuisine());
    this.selectAllForDropdownItems(this.getCategory());
    this.getRestaurants();
    this.dataSource.paginator = this.paginator;
    this.masterRestodataSource.paginator = this.paginator1;
  }
  positionOptions: TooltipPosition[] = ['below', 'above', 'left', 'right'];
  position = new FormControl(this.positionOptions[0]);
  dataSourceCopy = this.restaurantList;
  restoSeletedFlag: boolean = true
  noResto: number;
  noMasterResto: number;
  searchText: any;
  masterSearchText: any;
  flag = false;
  restopop = 0;
  timeArr = [1];
  dayArr = [1];
  mediaArr = [1];
  selectedCity: any;
  selectedCityIds: string[];
  selectedCityName: string;
  selectedCityId: number;
  selectedUserIds: number[];
  delete = false;
  src: string = "../../../assets/images/Ellipse 11.png";
  restoName: string = "";
  restoEmail: string = "";
  restoPhone: string = "";
  restoAddress: string = "";
  restoDescrip: string = "";
  restoPocName: string = "";
  restoPocId: string = "";
  restoLotitude: string = "";
  restoLogitude: string = "";
  restoServiceCharge: string = "";
  spiceTol: string = "";
  newRestoLevel: string = "";
  restoLevel: string = "";
  noOfTable: string = "";
  offerValue: string = "";

  restoEditName: string = "";
  restoEditEmail: string = "";
  restoEditPhone: string = "";
  restoEditAddress: string = "";
  restoEditDescrip: string = "";
  restoEditPocName: string = "";
  restoEditPocId: string = "";
  restoEditLotitude: string = "";
  restoEditLogitude: string = "";
  restoEditServiceCharge: string = "";
  spiceEditTol: string = "";
  noOfEditTable: string = "";
  editOfferValue: string = "";
  editSrc: string;
  restoLavelLable: string = ""
  restoEditLavelLable: string = ""
  featureSrc: string = "../../../assets/images/Ellipse 11.png";
  newFeatureSrc: string = "../../../assets/images/Ellipse 11.png";
  cities3 = [
    {
      id: 1,
      name: "Website",
      avatar: "../../../assets/images/web-svgrepo-com (1).png",
    },
    {
      id: 2,
      name: "Instagram",
      avatar: "../../../assets/images/instagram-svgrepo-com.png",
    },
    {
      id: 3,
      name: "Facebook",
      avatar: "../../../assets/images/facebook-svgrepo-com.png",
    },
    {
      id: 4,
      name: "Twitter",
      avatar: "../../../assets/images/twitter-svgrepo-com.png",
    },
    {
      id: 5,
      name: "Youtube",
      avatar: "../../../assets/images/youtube-svgrepo-com.png",
    },
  ];

  monOpenHH = ''
  monOpenMM = ''
  monOpenMead = 'am'
  monPrecheck
  monCloseHH = ''
  monCloseMM = ''
  monCloseMead = 'am'
  tueOpenHH = ''
  tueOpenMM = ''
  tueOpenMead = 'am'
  tueCloseHH = ''
  tueCloseMM = ''
  tueCloseMead = 'am'
  tuePrecheck
  wedOpenHH = ''
  wedOpenMM = ''
  wedOpenMead = 'am'
  wedCloseHH = ''
  wedCloseMM = ''
  wedCloseMead = 'am'
  wedPrecheck
  thurOpenHH = ''
  thurOpenMM = ''
  thurOpenMead = 'am'
  thurCloseHH = ''
  thurCloseMM = ''
  thurCloseMead = 'am'
  thurPrecheck
  friOpenHH = ''
  friOpenMM = ''
  friOpenMead = 'am'
  friCloseHH = ''
  friCloseMM = ''
  friCloseMead = 'am'
  friPrecheck
  satOpenHH = ''
  satOpenMM = ''
  satOpenMead = 'am'
  satCloseHH = ''
  satCloseMM = ''
  satCloseMead = 'am'
  satPrecheck
  sunOpenHH = ''
  sunOpenMM = ''
  sunOpenMead = 'am'
  sunCloseHH = ''
  sunCloseMM = ''
  sunCloseMead = 'am'
  sunPrecheck
  mondayClearCondition = false
  tuesdayClearCondition = false
  wednesdayClearCondition = false
  tursdayClearCondition = false
  fridayClearCondition = false
  saturdayClearCondition = false
  sundayClearCondition = false



  offerMonday = false
  offerTuesday = false
  offerWednesday = false
  offerTurusday = false
  offerFriday = false
  offerSaturday = false
  offerSunday = false
  offerMonValue = ''
  offerTueValue = ''
  offerWedValue = ''
  offerThurValue = ''
  offerFriValue = ''
  offerSatValue = ''
  offerSunValue = ''

  queAns = ''
  queAnsOtherText = ''

  allDieatary = [];
  allAllergens = []
  allCaategory = []
  allCuisine = []
  selectedDieatry: any = []
  selectedAllegens: any = []
  selectedCaategory: any = []
  selectedCuisine: any = []
  createdNewSelectedDieatry: any = []
  createdNewSelectedAllegens: any = []
  createdNewSelectedCaategory: any = []
  createdNewSelectedCuisine: any = []


  menuSrc: any[] = []
  menuPdfCondition
  menuImgCondition
  pdfConditionMenu: boolean = false
  imgConditionMenu: boolean = false
  menuLinkCondition = false
  menuImgToBeAppend: any[] = []
  menuPdfToBeAppend: any = null
  pdfMenuSrc = 'null'
  pdfRedirctVar: any = null
  featureImgToBeAppend: any = null
  urlLink = ''
  otherDescriptionOrTags = ''
  newFeatureImgToBeAppend: any = null

  getMasterResto() {
    this.httpSv.getMasterRestaurant().subscribe((res: any) => {
      if (res["status"]) {
        this.masterRestaurantList = res.data;
        this.masterRestodataSource = new MatTableDataSource(this.masterRestaurantList);
        this.noMasterResto = this.masterRestaurantList.length;
        console.log(this.masterRestodataSource.data)
        setTimeout(() => {
          this.masterRestodataSource.paginator = this.paginator1;
        })
      }
    }, err => {
      this.masterRestaurantList = []
    });
  }


  materResto() {
    console.log(this.restoSeletedFlag)
    if (!this.restoSeletedFlag) return
    this.restoSeletedFlag = false
    this.getMasterResto()
    this.assignPaginator()
  }
  restoList() {
    if (this.restoSeletedFlag) return
    this.restoSeletedFlag = true
    this.assignPaginator()
    // this.dataSource.data = this.restaurantList;
    // this.dataSource.paginator = this.paginator;
  }

  assignPaginator() {
    setTimeout(() => {
      if (this.restoSeletedFlag) {
        this.dataSource.paginator = this.paginator;
      } else {
        this.masterRestodataSource.paginator = this.paginator1;
      }
    });
  }


  onSelected(value: any) {
    this.spiceTol = value;
  }
  filter() {
    if (this.searchText == "") {
      if (!this.restoSeletedFlag) {
        this.dataSource = new MatTableDataSource(this.masterRestaurantList);
        this.dataSource.paginator = this.paginator;
      } else {
        this.masterRestodataSource = new MatTableDataSource(this.restaurantList);
        this.masterRestodataSource.paginator = this.paginator;
      }
    } else {
      if (!this.restoSeletedFlag) {
        let temp = this.masterRestaurantList.filter((ele: any) => {
          return ele.master_resto_name
            .toLocaleLowerCase()
            .match(this.searchText.toLocaleLowerCase()) ||
            ele.email
              .toLocaleLowerCase()
              .match(this.searchText.toLocaleLowerCase());
        });
        this.masterRestodataSource = new MatTableDataSource(temp);

        if (temp.length === 0) {
          let temp = this.restaurantList.filter((ele: any) => {
            return ele.restaurant_unique_id
              .toLocaleLowerCase()
              .match(this.searchText.toLocaleLowerCase());
          });
          this.masterRestodataSource = new MatTableDataSource(temp);
        }
        this.masterRestodataSource.paginator = this.paginator;
      }
      else {
        let temp = this.restaurantList.filter((ele: any) => {
          return ele.restaurant_name
            .toLocaleLowerCase()
            .match(this.searchText.toLocaleLowerCase());
        });
        this.dataSource = new MatTableDataSource(temp);

        if (temp.length === 0) {
          let temp = this.restaurantList.filter((ele: any) => {
            return ele.restaurant_unique_id
              .toLocaleLowerCase()
              .match(this.searchText.toLocaleLowerCase());
          });
          this.dataSource = new MatTableDataSource(temp);
        }
        this.dataSource.paginator = this.paginator;
      }
    }
  }
  masterFilter() {
    if (this.masterSearchText == "") {
      this.masterRestodataSource = new MatTableDataSource(this.masterRestaurantList);
      this.masterRestodataSource.paginator = this.paginator1;
    } else {
      let temp = this.masterRestaurantList.filter((ele: any) => {
        return ele.master_resto_name
          .toLocaleLowerCase()
          .match(this.masterSearchText.toLocaleLowerCase());
      });
      this.masterRestodataSource = new MatTableDataSource(temp);

      if (temp.length === 0) {
        let temp = this.masterRestaurantList.filter((ele: any) => {
          return ele.restaurant_unique_id
            .toLocaleLowerCase()
            .match(this.masterSearchText.toLocaleLowerCase());
        });
        this.masterRestodataSource = new MatTableDataSource(temp);
      }
      this.masterRestodataSource.paginator = this.paginator1;
    }
  }
  addResto() {
    this.restopop = 1;
  }

  addMasterResto() {
    const dialogRef = this.dialog.open(restaurantMasterAddPopup, {
      maxHeight: '90vh',
      data: {
        isEdit: false,
        restaurantList: this.restaurantList,
        selectedRestaurants: [],
      }
    })

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getMasterResto();
      }
    })
  }

  editMasterRestoFunc(element: any) {
    const dialogRef = this.dialog.open(restaurantMasterAddPopup, {
      maxHeight: '90vh',
      data: {
        isEdit: true,
        restaurantList: this.restaurantList,
        selectedRestaurants: element.assigned_resto.split(','),
        info: element,
      }
    })

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getMasterResto();
      }
    })
  }

  closeResto() {
    this.restopop = 0;
    // window.location.reload();
    this.getRestaurants();
  }
  timeAddBtn() {
    this.timeArr.push(1);
  }
  dayAddBtn() {
    this.dayArr.push(1);
  }
  mediaAddBtn() {
    this.mediaArr.push(1);
  }

  openDialog(id) {
    const dialogRef = this.dialog.open(DeletePopupComponent, {
      data: "restaurant",
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == "true") {
        const data = {
          restaurant_id: id,
        };
        // console.log(data);
        this.httpSv.deleteRestaurant(data).subscribe(
          (res) => {
            if (res["status"] == "TRUE") {
              this._snackBar.open("Restaurant Deleted");
              this.getRestaurants()
              setTimeout(() => {
                this._snackBar.dismiss();
              }, 2000);
            } else {
              this._snackBar.open(res["message"]);
              setTimeout(() => {
                this._snackBar.dismiss();
              }, 2000);
            }
          },
          (err: any) => {
            this._snackBar.open("Oops! something went wrong");
            setTimeout(() => {
              this._snackBar.dismiss();
            }, 2000);
            console.log(err);
          }
        );
      }
      // console.log(result);
    });
  }
  sendData: any = new FormData()
  onImageChange(event: any) {
    this.sendData.append("logo", event.target.files[0]);
    let file: File = event.target.files[0];
    let reader: FileReader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (e: any) => {
      this.src = e.target.result;
    };
  }
  submitRestoCreate(formData) {
    if (formData.valid && this.src != '../../../assets/images/Ellipse 11.png') {
      this.sendData.append('name', this.restoName)
      this.sendData.append('email', this.restoEmail)
      if (this.restoPocId) this.sendData.append('poc_id', this.restoPocId)
      else this.sendData.append('poc_id', "N/A")
      if (this.restoPocName) this.sendData.append('poc_name', this.restoPocName)
      else this.sendData.append('poc_name', "N/A")
      this.sendData.append('address', this.restoAddress)
      this.sendData.append('telephone', this.restoPhone)
      this.sendData.append('spice_tollerence_level', this.spiceTol)
      if (this.restoServiceCharge) this.sendData.append('service_charge', this.restoServiceCharge)
      else this.sendData.append('service_charge', "N/A")
      this.sendData.append('restaurant_lat', this.restoLotitude)
      this.sendData.append('restaurant_long', this.restoLogitude)
      if (this.noOfTable) this.sendData.append('num_of_table', this.noOfTable)
      else this.sendData.append('num_of_table', "N/A")
      this.sendData.append('category', this.createdNewSelectedCaategory)
      this.sendData.append('cuisine', this.createdNewSelectedCuisine)
      this.sendData.append('allergens', this.createdNewSelectedAllegens)
      this.sendData.append('dietary_preferences', this.createdNewSelectedDieatry)
      if (this.newFeatureSrc != '../../../assets/images/Ellipse 11.png') {
        if (this.newFeatureImgToBeAppend) this.sendData.append('featured_image', this.newFeatureImgToBeAppend)
        else this.sendData.append('featured_image', this.newFeatureSrc)
      }
      this.sendData.append('level_of_restaurant', this.newRestoLevel)
      let mon = this.monPrecheck ? "Monday:" + this.monOpenHH + ":" + this.monOpenMM + ":" + this.monOpenMead + ':' + this.monCloseHH + ':' + this.monCloseMM + ':' + this.monCloseMead : "Monday:null"
      let tue = this.tuePrecheck ? `Tuesday:${this.tueOpenHH}:${this.tueOpenMM}:${this.tueOpenMead}:${this.tueCloseHH}:${this.tueCloseMM}:${this.tueCloseMead}` : 'Tuesday:null'
      let wed = this.wedPrecheck ? `Wednesday:${this.wedOpenHH}:${this.wedOpenMM}:${this.wedOpenMead}:${this.wedCloseHH}:${this.wedCloseMM}:${this.wedCloseMead}` : 'Wednesday:null'
      let thur = this.thurPrecheck ? `Thursday:${this.thurOpenHH}:${this.thurOpenMM}:${this.thurOpenMead}:${this.thurCloseHH}:${this.thurCloseMM}:${this.thurCloseMead}` : 'Thursday:null'
      let fri = this.friPrecheck ? `Friday:${this.friOpenHH}:${this.friOpenMM}:${this.friOpenMead}:${this.friCloseHH}:${this.friCloseMM}:${this.friCloseMead}` : 'Friday:null'
      let sat = this.satPrecheck ? `Saturday:${this.satOpenHH}:${this.satOpenMM}:${this.satOpenMead}:${this.satCloseHH}:${this.satCloseMM}:${this.satCloseMead}` : 'Saturday:null'
      let sun = this.sunPrecheck ? `Sunday:${this.sunOpenHH}:${this.sunOpenMM}:${this.sunOpenMead}:${this.sunCloseHH}:${this.sunCloseMM}:${this.sunCloseMead}` : 'Sunday:null'
      let time = `${mon},${tue},${wed},${thur},${fri},${sat},${sun}`
      this.sendData.append('opening_hours', time)
      let monOffer = this.offerMonday ? "Monday:" + this.offerMonValue : "Monday:null"
      let tueOffer = this.offerTuesday ? "Tuesday:" + this.offerTueValue : "Tuesday:null"
      let wedOffer = this.offerWednesday ? "Wednesday:" + this.offerWedValue : "Wednesday:null"
      let thurOffer = this.offerTurusday ? "Thursday:" + this.offerThurValue : "Thursday:null"
      let friOffer = this.offerFriday ? "Friday:" + this.offerFriValue : "Friday:null"
      let satOffer = this.offerSaturday ? "Saturday:" + this.offerSatValue : "Saturday:null"
      let sunOffer = this.offerSunday ? "Sunday:" + this.offerSunValue : "Sunday:null"
      let finalOffer = `${monOffer},${tueOffer},${wedOffer},${thurOffer},${friOffer},${satOffer},${sunOffer}`
      this.sendData.append('special_offer', finalOffer)
      if (this.queAns && this.queAns != 'D') this.sendData.append('appropriate_food_allergy_message', this.queAns)
      else if (this.queAns && this.queAns == 'D') this.sendData.append('appropriate_food_allergy_message', this.queAnsOtherText)
      if (this.menuLinkCondition) {
        console.log('link-inside')
        this.sendData.append('menu_name_link[]', this.urlLink)
      } else {

        if (this.pdfRedirctVar) {
          if (this.menuPdfToBeAppend) {
            console.log('pdfCheck1')
            this.sendData.append('menu_name[]', this.menuPdfToBeAppend)
          }
          else {
            console.log('pdfCheck2')
            this.sendData.append('menu_name_link[]', this.pdfMenuSrc)
          }
        }
        else {
          let link: any = []
          if (this.menuSrc.length == this.menuImgToBeAppend.length) {
            this.menuImgToBeAppend.forEach(ele => {
              this.sendData.append('menu_name[]', ele)
            })
          }
          else {
            if (this.menuImgToBeAppend.length > 0) {
              this.menuImgToBeAppend.forEach(ele => {
                this.sendData.append('menu_name[]', ele)
              })
            }
            this.menuSrc.forEach(ele => {
              // if (ele.src.includes('http')) this.sendData.append('menu_name_link[]', ele.src)
              if (ele.src.includes('http')) link.push(ele.src)
            })
            this.sendData.append('menu_name_link[]', link)
          }
        }
      }
      let deleviroo = this.delverooCon ? 'Deliveroo:' + this.delverooVal : 'Deliveroo:null'
      let justeat = this.justEatCon ? 'JustEat:' + this.justEatVal : 'JustEat:null'
      let ubereat = this.uberEatsCon ? 'UberEats:' + this.uberEatsVal : 'UberEats:null'
      let foodstuf = this.foodstuffCon ? 'Foodstuff:' + this.foodstuffVal : 'Foodstuff:null'
      let deleveryPartner = `${deleviroo},${justeat},${ubereat},${foodstuf}`
      this.sendData.append('delivery_partner', deleveryPartner)
      if (this.instagramCon) this.sendData.append('instagram_link', this.instagramVal)
      else this.sendData.append('instagram_link', null)
      if (this.facebookCon) this.sendData.append('social_link', this.facebookVal)
      if (this.googleMapCon) this.sendData.append('google_map_url', this.googleMapVal)
      else this.sendData.append('google_map_url', null)
      if (this.otherDescriptionOrTags.length > 0) this.sendData.append('description_and_tags', this.otherDescriptionOrTags)
      this.httpSv.createRestaurant(this.sendData).subscribe(
        (res) => {
          if (res["status"] == "TRUE") {
            this.closeEditFunc()
            this.getRestaurants();
            this.restopop = 0;
            this._snackBar.open("Restaurant is created");
            setTimeout(() => {
              this._snackBar.dismiss();
            }, 2000);
          } else {
            this._snackBar.open(res["message"]);
            setTimeout(() => {
              this._snackBar.dismiss();
            }, 2000);
          }
        },
        (err: any) => {
          this._snackBar.open("Oops! something went wrong");
          setTimeout(() => {
            this._snackBar.dismiss();
          }, 2000);
          console.log(err);
        }
      );
      this.restopop = 0;
    }
    else if (this.src == '../../../assets/images/Ellipse 11.png' && formData.valid) {
      this._snackBar.open('Restaurant Logo is Missing')
      setTimeout(() => {
        this._snackBar.dismiss()
      }, 2000)
    }
    else {
      this._snackBar.open('Required feilds are missing')
      setTimeout(() => {
        this._snackBar.dismiss()
      }, 2000)
    }
  }
  editRestoId
  editSendData = new FormData()
  updateRestoFunc(id: any) {
    // this.editRestoId = window.atob(id);
    this.editRestoId = id;
    this.httpSv.getOneRestoDetails(this.editRestoId).subscribe((res) => {
      if (res["status"] == "TRUE") {
        // console.log(res);
        let temp = res["result"].data;
        this.restoEditName = temp.restaurant_name;
        this.restoEditEmail = temp.restaurant_email;
        this.restoEditPhone = temp.restaurant_telephone;
        this.restoEditAddress = temp.restaurant_address;
        this.restoEditAddress = temp.restaurant_address;
        this.restoEditDescrip = temp.description
        this.restoEditPocName = temp.restaurant_poc_name;
        this.restoEditPocId = temp.restaurant_poc_number;
        this.restoEditLotitude = temp.restaurant_lat;
        this.restoEditLogitude = temp.restaurant_long;
        this.restoEditServiceCharge = temp.restaurant_service_charge;
        this.spiceEditTol = temp.restaurant_spice_tollerence;
        this.noOfEditTable = temp.restaurant_no_of_tables;
        // this.editOfferValue = temp.
        this.editSrc = temp.logo;
        // this.editSrc = temp.restaurant_image;

        if (typeof (temp.categories) != 'string' && temp.categories)
          this.selectedCaategory = temp.categories.map(ele => ele.id)


        if (typeof (temp.cuisine) != 'string' && temp.cuisine)
          this.selectedCuisine = temp.cuisine.map(ele => ele.id)


        if (typeof (temp.dietary_preferences) != 'string' && temp.dietary_preferences)
          this.selectedDieatry = temp.dietary_preferences.map(ele => ele.id)


        if (typeof (temp.allergens) != 'string' && temp.allergens)
          this.selectedAllegens = temp.allergens.map(ele => ele.id)


        if (temp.featured_image) {
          this.featureSrc = temp.featured_image
        }
        if (temp.opening_hours) {
          let time = temp.opening_hours.split(',')
          time.forEach(element => {
            let day = element.split(':')[0]
            let temp1 = element.split(':')
            if (day == 'Monday') {
              if (temp1[1] != 'null') {
                this.monOpenHH = temp1[1]
                this.monOpenMM = temp1[2]
                this.monOpenMead = temp1[3]
                this.monCloseHH = temp1[4]
                this.monCloseMM = temp1[5]
                this.monCloseMead = temp1[6]
                this.monPrecheck = true
                this.mondayClearCondition = true
              }
            }
            else if (day == 'Tuesday') {
              if (temp1[1] != 'null') {
                this.tueOpenHH = temp1[1]
                this.tueOpenMM = temp1[2]
                this.tueOpenMead = temp1[3]
                this.tueCloseHH = temp1[4]
                this.tueCloseMM = temp1[5]
                this.tueCloseMead = temp1[6]
                this.tuePrecheck = true
                this.tuesdayClearCondition = true
              }
            }
            else if (day == 'Wednesday') {
              if (temp1[1] != 'null') {
                this.wedOpenHH = temp1[1]
                this.wedOpenMM = temp1[2]
                this.wedOpenMead = temp1[3]
                this.wedCloseHH = temp1[4]
                this.wedCloseMM = temp1[5]
                this.wedCloseMead = temp1[6]
                this.wedPrecheck = true
                this.wednesdayClearCondition = true
              }
            }
            else if (day == 'Thursday') {
              if (temp1[1] != 'null') {
                this.thurOpenHH = temp1[1]
                this.thurOpenMM = temp1[2]
                this.thurOpenMead = temp1[3]
                this.thurCloseHH = temp1[4]
                this.thurCloseMM = temp1[5]
                this.thurCloseMead = temp1[6]
                this.thurPrecheck = true
                this.tursdayClearCondition = true

              }
            }
            else if (day == 'Friday') {
              if (temp1[1] != 'null') {
                this.friOpenHH = temp1[1]
                this.friOpenMM = temp1[2]
                this.friOpenMead = temp1[3]
                this.friCloseHH = temp1[4]
                this.friCloseMM = temp1[5]
                this.friCloseMead = temp1[6]
                this.friPrecheck = true
                this.fridayClearCondition = true
              }
            }
            else if (day == 'Saturday') {
              if (temp1[1] != 'null') {
                this.satOpenHH = temp1[1]
                this.satOpenMM = temp1[2]
                this.satOpenMead = temp1[3]
                this.satCloseHH = temp1[4]
                this.satCloseMM = temp1[5]
                this.satCloseMead = temp1[6]
                this.satPrecheck = true
                this.saturdayClearCondition = true
              }
            }
            else {
              if (temp1[1] != 'null') {
                this.sunOpenHH = temp1[1]
                this.sunOpenMM = temp1[2]
                this.sunOpenMead = temp1[3]
                this.sunCloseHH = temp1[4]
                this.sunCloseMM = temp1[5]
                this.sunCloseMead = temp1[6]
                this.sunPrecheck = true
                this.sundayClearCondition = true
              }
            }
          });
        }
        if (temp.special_offer) {
          let offersArr = temp.special_offer.split(',')
          offersArr.forEach(element => {
            let day = element.split(':')[0]
            let temp1 = element.split(':')
            if (day == 'Monday') {
              if (temp1[1] != 'null') {
                this.offerMonday = true
                this.offerMonValue = temp1[1]
              }
            }
            else if (day == 'Tuesday') {
              if (temp1[1] != 'null') {
                this.offerTuesday = true
                this.offerTueValue = temp1[1]
              }
            }
            else if (day == 'Wednesday') {
              if (temp1[1] != 'null') {
                this.offerWednesday = true
                this.offerWedValue = temp1[1]
              }
            }
            else if (day == 'Thursday') {
              if (temp1[1] != 'null') {
                this.offerTurusday = true
                this.offerThurValue = temp1[1]

              }
            }
            else if (day == 'Friday') {
              if (temp1[1] != 'null') {
                this.offerFriday = true
                this.offerFriValue = temp1[1]
              }
            }
            else if (day == 'Saturday') {
              if (temp1[1] != 'null') {
                this.offerSaturday = true
                this.offerSatValue = temp1[1]
              }
            }
            else {
              if (temp1[1] != 'null') {
                this.offerSunday = true
                this.offerSunValue = temp1[1]
              }
            }
          });
        }
        if (temp.appropriate_food_allergy_message) {
          if (temp.appropriate_food_allergy_message == 'A' || temp.appropriate_food_allergy_message == 'B' || temp.appropriate_food_allergy_message == 'C')
            this.queAns = temp.appropriate_food_allergy_message
          else {
            this.queAns = 'D'
            this.queAnsOtherText = temp.appropriate_food_allergy_message
          }
        }
        if (temp.menu_name_link) {
          let menuNameLink = temp.menu_name_link
          // if (temp.menu_name_link.length > 1) menuNameLink = temp.menu_name_link[0].split(',')
          // else menuNameLink = temp.menu_name_link[0]
          console.log(menuNameLink[0].includes('.jpg'))
          if (menuNameLink[0].includes('.pdf') || menuNameLink.length > 1 || menuNameLink[0].includes('.png') || menuNameLink[0].includes('.jpg') || menuNameLink[0].includes('.jpeg') || menuNameLink[0].includes('.svg')) {
            console.log('menuNameLink[0].includes()')
            if (temp.menu_name) {
              if (temp.menu_name[0].includes('.pdf')) {
                this.menuPdfCondition = true
                this.pdfRedirctVar = temp.menu_name[0]
                let splitArr = temp.menu_name[0].split('/')
                this.pdfMenuSrc = splitArr[splitArr.length - 1]
                this.pdfConditionMenu = true
              }
              else if ((temp.menu_name.length > 1 || temp.menu_name[0].includes('.png') || temp.menu_name[0].includes('.jpg') || temp.menu_name[0].includes('.jpeg') || temp.menu_name[0].includes('.svg'))) {
                this.menuImgCondition = true
                temp.menu_name.forEach(element => {
                  this.menuSrc.push({ src: element })
                });
                this.imgConditionMenu = true
              }
            }
            if (temp.menu_name_link) {
              let menuNameLink = temp.menu_name_link
              if (menuNameLink[0].includes('.pdf')) {
                this.menuPdfCondition = true
                console.log(temp.menu_name_link[0]);

                this.pdfRedirctVar = temp.menu_name_link[0]
                console.log(this.pdfRedirctVar);

                let splitArr = temp.menu_name_link[0].split('/')
                this.pdfMenuSrc = splitArr[splitArr.length - 1]
                this.pdfConditionMenu = true
              }
              else if ((menuNameLink.length > 1 || menuNameLink[0].includes('.png') || menuNameLink[0].includes('.jpg') || menuNameLink[0].includes('.jpeg') || menuNameLink[0].includes('.svg')) && typeof (menuNameLink) != 'string') {
                // console.log('works 2')
                this.menuImgCondition = true
                menuNameLink.forEach(element => {
                  this.menuSrc.push({ src: element })
                });
                this.imgConditionMenu = true
              }
            }
          }
          else {
            this.menuLinkCondition = true
            this.urlLink = menuNameLink
          }
        }
        else {
          if (temp.menu_name) {
            if (temp.menu_name[0].includes('.pdf')) {
              this.menuPdfCondition = true
              this.pdfRedirctVar = temp.menu_name[0]
              let splitArr = temp.menu_name[0].split('/')
              this.pdfMenuSrc = splitArr[splitArr.length - 1]
              this.pdfConditionMenu = true
            }
            else if ((temp.menu_name.length > 1 || temp.menu_name[0].includes('.png') || temp.menu_name[0].includes('.jpg') || temp.menu_name[0].includes('.jpeg') || temp.menu_name[0].includes('.svg')) && typeof (temp.menu_name) != 'string') {
              this.menuImgCondition = true
              temp.menu_name.forEach(element => {
                this.menuSrc.push({ src: element })
              });
              this.imgConditionMenu = true
            }
          }
        }
        if (temp.delivery_partner) {
          let deliverArr = temp.delivery_partner.split(',')
          console.log(deliverArr)
          deliverArr.forEach(element => {
            let [partnerName, ...temp1] = element.split(':')
            temp1 = temp1.join(':')
            // console.log(partnerName, temp1)
            // let temp1 = element.split(':')
            if (partnerName == 'Deliveroo') {
              if (temp1 != 'null') {
                this.delverooCon = true
                this.delverooVal = temp1
              }
            }
            else if (partnerName == 'JustEat') {
              if (temp1 != 'null') {
                this.justEatCon = true
                this.justEatVal = temp1
              }
            }
            else if (partnerName == 'UberEats') {
              if (temp1 != 'null') {
                this.uberEatsCon = true
                this.uberEatsVal = temp1
              }
            }
            else if (partnerName == 'Foodstuff') {
              if (temp1 != 'null') {
                this.foodstuffCon = true
                this.foodstuffVal = temp1
              }
            }

          });
        }
        if (temp.instagram_link && temp.instagram_link != 'NA' && temp.instagram_link != 'null') {
          this.instagramCon = true
          this.instagramVal = temp.instagram_link
        }
        if (temp.social_link) {
          this.facebookCon = true
          this.facebookVal = temp.social_link
        }
        if (temp.google_map_url && temp.google_map_url != 'null') {
          this.googleMapCon = true
          this.googleMapVal = temp.google_map_url
        }
        if (temp.description_and_tags) {
          this.otherDescriptionOrTags = temp.description_and_tags
        }
        this.restoLevel = temp.level_of_restaurant
        this.restoEditLavelLable = temp.label
        this.restopop = 2;
      }
    });
  }
  submitEditRestoCreate(formData) {
    if (formData) {
      this.editSendData.append('name', this.restoEditName)
      this.editSendData.append('email', this.restoEditEmail)
      this.editSendData.append('description', this.restoEditDescrip)
      if (this.restoEditPocId) this.editSendData.append('poc_id', this.restoEditPocId)
      else this.editSendData.append('poc_id', 'N/A')
      if (this.restoEditPocName) this.editSendData.append('poc_name', this.restoEditPocName)
      else this.editSendData.append('poc_name', 'N/A')
      this.editSendData.append('address', this.restoEditAddress)
      this.editSendData.append('telephone', this.restoEditPhone)
      this.editSendData.append('spice_tollerence_level', this.spiceEditTol)
      if (this.restoEditServiceCharge) this.editSendData.append('service_charge', this.restoEditServiceCharge)
      else this.editSendData.append('service_charge', 'N/A')
      this.editSendData.append('restaurant_lat', this.restoEditLotitude)
      this.editSendData.append('restaurant_long', this.restoEditLogitude)
      if (this.noOfEditTable) this.editSendData.append('no_of_tables', this.noOfEditTable)
      else this.editSendData.append('no_of_tables', 'N/A')
      this.editSendData.append('restaurant_id', this.editRestoId)


      this.editSendData.append('category', this.selectedCaategory)
      this.editSendData.append('cuisine', this.selectedCuisine)
      this.editSendData.append('allergens', this.selectedAllegens)
      this.editSendData.append('dietary_preferences', this.selectedDieatry)


      if (this.featureSrc != '../../../assets/images/Ellipse 11.png') {
        if (this.featureImgToBeAppend) this.editSendData.append('featured_image', this.featureImgToBeAppend)
        else this.editSendData.append('featured_image', this.featureSrc)
      }
      let mon = this.monPrecheck ? "Monday:" + this.monOpenHH + ":" + this.monOpenMM + ":" + this.monOpenMead + ':' + this.monCloseHH + ':' + this.monCloseMM + ':' + this.monCloseMead : "Monday:null"
      let tue = this.tuePrecheck ? `Tuesday:${this.tueOpenHH}:${this.tueOpenMM}:${this.tueOpenMead}:${this.tueCloseHH}:${this.tueCloseMM}:${this.tueCloseMead}` : 'Tuesday:null'
      let wed = this.wedPrecheck ? `Wednesday:${this.wedOpenHH}:${this.wedOpenMM}:${this.wedOpenMead}:${this.wedCloseHH}:${this.wedCloseMM}:${this.wedCloseMead}` : 'Wednesday:null'
      let thur = this.thurPrecheck ? `Thursday:${this.thurOpenHH}:${this.thurOpenMM}:${this.thurOpenMead}:${this.thurCloseHH}:${this.thurCloseMM}:${this.thurCloseMead}` : 'Thursday:null'
      let fri = this.friPrecheck ? `Friday:${this.friOpenHH}:${this.friOpenMM}:${this.friOpenMead}:${this.friCloseHH}:${this.friCloseMM}:${this.friCloseMead}` : 'Friday:null'
      let sat = this.satPrecheck ? `Saturday:${this.satOpenHH}:${this.satOpenMM}:${this.satOpenMead}:${this.satCloseHH}:${this.satCloseMM}:${this.satCloseMead}` : 'Saturday:null'
      let sun = this.sunPrecheck ? `Sunday:${this.sunOpenHH}:${this.sunOpenMM}:${this.sunOpenMead}:${this.sunCloseHH}:${this.sunCloseMM}:${this.sunCloseMead}` : 'Sunday:null'
      let time = `${mon},${tue},${wed},${thur},${fri},${sat},${sun}`
      this.editSendData.append('opening_hours', time)
      let monOffer = this.offerMonday ? "Monday:" + this.offerMonValue : "Monday:null"
      let tueOffer = this.offerTuesday ? "Tuesday:" + this.offerTueValue : "Tuesday:null"
      let wedOffer = this.offerWednesday ? "Wednesday:" + this.offerWedValue : "Wednesday:null"
      let thurOffer = this.offerTurusday ? "Thursday:" + this.offerThurValue : "Thursday:null"
      let friOffer = this.offerFriday ? "Friday:" + this.offerFriValue : "Friday:null"
      let satOffer = this.offerSaturday ? "Saturday:" + this.offerSatValue : "Saturday:null"
      let sunOffer = this.offerSunday ? "Sunday:" + this.offerSunValue : "Sunday:null"
      let finalOffer = `${monOffer},${tueOffer},${wedOffer},${thurOffer},${friOffer},${satOffer},${sunOffer}`
      this.editSendData.append('special_offer', finalOffer)
      if (this.queAns && this.queAns != 'D') this.editSendData.append('appropriate_food_allergy_message', this.queAns)
      else if (this.queAns && this.queAns == 'D') this.editSendData.append('appropriate_food_allergy_message', this.queAnsOtherText)
      if (this.menuLinkCondition) {
        console.log('link-inside')
        this.editSendData.append('menu_name_link[]', this.urlLink)
      } else {

        if (this.pdfRedirctVar) {
          if (this.menuPdfToBeAppend) {
            console.log('pdfCheck1')
            this.editSendData.append('menu_name[]', this.menuPdfToBeAppend)
          }
          else {
            console.log('pdfCheck2')
            this.editSendData.append('menu_name_link[]', this.pdfMenuSrc)
          }
        }
        else {
          let link: any = []
          if (this.menuSrc.length == this.menuImgToBeAppend.length) {
            this.menuImgToBeAppend.forEach(ele => {
              this.editSendData.append('menu_name[]', ele)
            })
          }
          else {
            if (this.menuImgToBeAppend.length > 0) {
              this.menuImgToBeAppend.forEach(ele => {
                this.editSendData.append('menu_name[]', ele)
              })
            }
            this.menuSrc.forEach(ele => {
              // if (ele.src.includes('http')) this.sendData.append('menu_name_link[]', ele.src)
              if (ele.src.includes('http')) link.push(ele.src)
            })
            this.editSendData.append('menu_name_link[]', link)
          }
        }
      }
      let deleviroo = this.delverooCon ? 'Deliveroo:' + this.delverooVal : 'Deliveroo:null'
      let justeat = this.justEatCon ? 'JustEat:' + this.justEatVal : 'JustEat:null'
      let ubereat = this.uberEatsCon ? 'UberEats:' + this.uberEatsVal : 'UberEats:null'
      let foodstuf = this.foodstuffCon ? 'Foodstuff:' + this.foodstuffVal : 'Foodstuff:null'
      let deleveryPartner = `${deleviroo},${justeat},${ubereat},${foodstuf}`
      this.editSendData.append('delivery_partner', deleveryPartner)
      if (this.instagramCon) this.editSendData.append('instagram_link', this.instagramVal)
      else this.editSendData.append('instagram_link', null)
      if (this.facebookCon) this.editSendData.append('social_link', this.facebookVal)
      if (this.googleMapCon) this.editSendData.append('google_map_url', this.googleMapVal)
      else this.editSendData.append('google_map_url', null)
      if (this.otherDescriptionOrTags.length > 0) this.editSendData.append('description_and_tags', this.otherDescriptionOrTags)
      this.editSendData.append('label', this.restoEditLavelLable)



      this.httpSv.updateRestaurant(this.editSendData).subscribe(res => {
        if (res["status"] == true) {
          this.closeEditFunc()
          this._snackBar.open("Restaurant is updated");
          setTimeout(() => {
            this._snackBar.dismiss();
          }, 2000);
        } else {
          this._snackBar.open(res["message"]);
          setTimeout(() => {
            this._snackBar.dismiss();
          }, 2000);
        }
      }, (err: any) => {
        this._snackBar.open("Oops! something went wrong");
        setTimeout(() => {
          this._snackBar.dismiss();
        }, 2000);
        console.log(err);
      })
    }
    else {
      this._snackBar.open('Required feilds are missing')
      setTimeout(() => {
        this._snackBar.dismiss()
      }, 2000)
    }
  }
  closeEditFunc() {
    this.restopop = 0;
    this.getRestaurants();
    this.restoEditName = "";
    this.restoEditEmail = "";
    this.restoEditPhone = "";
    this.restoEditAddress = "";
    this.restoEditDescrip = "";
    this.restoEditPocName = "";
    this.restoEditPocId = "";
    this.restoEditLotitude = "";
    this.restoEditLogitude = "";
    this.restoEditServiceCharge = "";
    this.spiceEditTol = "";
    this.noOfEditTable = "";
    this.editOfferValue = "";
    this.editSrc = "../../../assets/images/Ellipse 11.png"
    this.featureSrc = "../../../assets/images/Ellipse 11.png";
    this.monOpenHH = ''
    this.monOpenMM = ''
    this.monOpenMead = 'am'
    this.monPrecheck = false
    this.monCloseHH = ''
    this.monCloseMM = ''
    this.monCloseMead = 'am'
    this.tueOpenHH = ''
    this.tueOpenMM = ''
    this.tueOpenMead = 'am'
    this.tueCloseHH = ''
    this.tueCloseMM = ''
    this.tueCloseMead = 'am'
    this.tuePrecheck = false
    this.wedOpenHH = ''
    this.wedOpenMM = ''
    this.wedOpenMead = 'am'
    this.wedCloseHH = ''
    this.wedCloseMM = ''
    this.wedCloseMead = 'am'
    this.wedPrecheck = false
    this.thurOpenHH = ''
    this.thurOpenMM = ''
    this.thurOpenMead = 'am'
    this.thurCloseHH = ''
    this.thurCloseMM = ''
    this.thurCloseMead = 'am'
    this.thurPrecheck = false
    this.friOpenHH = ''
    this.friOpenMM = ''
    this.friOpenMead = 'am'
    this.friCloseHH = ''
    this.friCloseMM = ''
    this.friCloseMead = 'am'
    this.friPrecheck = false
    this.satOpenHH = ''
    this.satOpenMM = ''
    this.satOpenMead = 'am'
    this.satCloseHH = ''
    this.satCloseMM = ''
    this.satCloseMead = 'am'
    this.satPrecheck = false
    this.sunOpenHH = ''
    this.sunOpenMM = ''
    this.sunOpenMead = 'am'
    this.sunCloseHH = ''
    this.sunCloseMM = ''
    this.sunCloseMead = 'am'
    this.sunPrecheck = false
    this.mondayClearCondition = false
    this.tuesdayClearCondition = false
    this.wednesdayClearCondition = false
    this.tursdayClearCondition = false
    this.fridayClearCondition = false
    this.saturdayClearCondition = false
    this.sundayClearCondition = false

    this.offerMonday = false
    this.offerTuesday = false
    this.offerWednesday = false
    this.offerTurusday = false
    this.offerFriday = false
    this.offerSaturday = false
    this.offerSunday = false
    this.offerMonValue = ''
    this.offerTueValue = ''
    this.offerWedValue = ''
    this.offerThurValue = ''
    this.offerFriValue = ''
    this.offerSatValue = ''
    this.offerSunValue = ''

    this.queAns = ''
    this.queAnsOtherText = ''

    // this.allDieatary = [];
    // this.allAllergens = []
    // this.allCaategory = []
    // this.allCuisine = []
    this.selectedDieatry = []
    this.selectedAllegens = []
    this.selectedCaategory = []
    this.selectedCuisine = []

    this.menuSrc = []
    // this.menuPdfCondition
    // this.menuImgCondition
    this.pdfConditionMenu = false
    this.imgConditionMenu = false
    this.menuLinkCondition = false
    this.menuImgToBeAppend = []
    this.menuPdfToBeAppend = null
    this.pdfMenuSrc = 'null'
    this.pdfRedirctVar = null

    this.delverooCon = false
    this.justEatCon = false
    this.uberEatsCon = false
    this.foodstuffCon = false
    this.delverooVal = null
    this.justEatVal = null
    this.uberEatsVal = null
    this.foodstuffVal = null

    this.instagramCon = false
    this.facebookCon = false
    this.googleMapCon = false
    this.instagramVal = null
    this.facebookVal = null
    this.googleMapVal = null
    this.otherDescriptionOrTags = ''

    this.restoName = "";
    this.restoEmail = "";
    this.restoPhone = "";
    this.restoAddress = "";
    this.restoDescrip = "";
    this.restoPocName = "";
    this.restoPocId = "";
    this.restoLotitude = "";
    this.restoLogitude = "";
    this.restoServiceCharge = "";
    this.spiceTol = "";
    this.newRestoLevel = "";
    this.restoLevel = "";
    this.noOfTable = "";
    this.offerValue = "";
    this.newRestoLevel = "";
    this.restoLevel = "";
    this.src = "../../../assets/images/Ellipse 11.png";
    this.newFeatureSrc = "../../../assets/images/Ellipse 11.png"
    this.createdNewSelectedDieatry = []
    this.createdNewSelectedAllegens = []
    this.createdNewSelectedCaategory = []
    this.createdNewSelectedCuisine = []
    this.restoLavelLable = ''
    this.restoEditLavelLable = ''
    this.editSendData = new FormData()
    this.sendData = new FormData()

  }
  oneEditImageChange(event: any, id) {
    const fsize = event.target.files[0].size;
    const fileSize = (fsize / 1024);
    if (fileSize > 500) {
      this._snackBar.open(`Image can't be uploaded, as the size is bigger than 500 kb`)
      setTimeout(() => { this._snackBar.dismiss() }, 3000)
      document.getElementById(id)['value'] = ''
      // alert(`Sorry this is can't be uploaded .The image size is greater than 500kb`)
      return
    }
    this.editSendData.append("logo", event.target.files[0]);
    let file: File = event.target.files[0];
    let reader: FileReader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (e: any) => {
      this.editSrc = e.target.result;
    };
  }
  activateRestoFunc(id) {
    const dilogRef = this.dialog.open(restaurantDeletePopup)
    dilogRef.afterClosed().subscribe(result => {
      if (result == 'true') {
        const data = { restaurant_id: id }
        // this.httpSv.activateRestaurant(data).subscribe(res => {
        //   if (res['status'] == 'TRUE') {
        //     this._snackBar.open('Restaurant is active now!!')
        //     this.getRestaurants()
        //     setTimeout(() => {
        //       this._snackBar.dismiss()
        //     }, 2000)
        //   } else {
        //     this._snackBar.open(res['message'])
        //     setTimeout(() => {
        //       this._snackBar.dismiss()
        //     }, 2000)
        //   }
        // }, err => {
        //   this._snackBar.open('Oops!! Something went wrong')
        //   setTimeout(() => {
        //     this._snackBar.dismiss()
        //   }, 2000)
        // })
      }
    })
  }
  getRestaurants() {
    this.httpSv.getAllrestaurantsList().subscribe(
      (res: any) => {
        if (res["status"] == "TRUE") {
          this.restaurantList = res["result"].data;
          this.dataSource.data = res["result"].data;
          this.dataSource.paginator = this.paginator;
          this.noResto = res["result"].data.length;
        }
      },
      (err: any) => {
        console.log(err);
      }
    );
  }
  viewRestoFunc(id) {
    let temp = id
    localStorage.setItem('restoID', temp)
    this.router.navigate(['/admin/viewresto'])
  }
  copyTimeFunc(day) {
    if (day == 'tue') {
      this.tueOpenHH = this.monOpenHH
      this.tueOpenMM = this.monOpenMM
      this.tueOpenMead = this.monOpenMead
      this.tueCloseHH = this.monCloseHH
      this.tueCloseMM = this.monCloseMM
      this.tueCloseMead = this.monCloseMead

    }
    else if (day == 'wed') {
      this.wedOpenHH = this.tueOpenHH
      this.wedOpenMM = this.tueOpenMM
      this.wedOpenMead = this.tueOpenMead
      this.wedCloseHH = this.tueCloseHH
      this.wedCloseMM = this.tueCloseMM
      this.wedCloseMead = this.tueCloseMead
    }
    else if (day == 'thur') {
      this.thurOpenHH = this.wedOpenHH
      this.thurOpenMM = this.wedOpenMM
      this.thurOpenMead = this.wedOpenMead
      this.thurCloseHH = this.wedCloseHH
      this.thurCloseMM = this.wedCloseMM
      this.thurCloseMead = this.wedCloseMead
    }
    else if (day == 'fri') {
      this.friOpenHH = this.thurOpenHH
      this.friOpenMM = this.thurOpenMM
      this.friOpenMead = this.thurOpenMead
      this.friCloseHH = this.thurCloseHH
      this.friCloseMM = this.thurCloseMM
      this.friCloseMead = this.thurCloseMead
    }
    else if (day == 'sat') {
      this.satOpenHH = this.friOpenHH
      this.satOpenMM = this.friOpenMM
      this.satOpenMead = this.friOpenMead
      this.satCloseHH = this.friCloseHH
      this.satCloseMM = this.friCloseMM
      this.satCloseMead = this.friCloseMead
    }
    else if (day == 'sun') {
      this.sunOpenHH = this.satOpenHH
      this.sunOpenMM = this.satOpenMM
      this.sunOpenMead = this.satOpenMead
      this.sunCloseHH = this.satCloseHH
      this.sunCloseMM = this.satCloseMM
      this.sunCloseMead = this.satCloseMead
    }

  }
  timeClear(id) {
    if (id == 'mondayTime') {
      this.monOpenHH = ''
      this.monOpenMM = ''
      this.monOpenMead = 'am'
      this.monCloseHH = ''
      this.monCloseMM = ''
      this.monCloseMead = 'am'
    }
    else if (id == 'tuesdayTime') {
      this.tueOpenHH = ''
      this.tueOpenMM = ''
      this.tueOpenMead = 'am'
      this.tueCloseHH = ''
      this.tueCloseMM = ''
      this.tueCloseMead = 'am'
    }
    else if (id == 'wednesTime') {
      this.wedOpenHH = ''
      this.wedOpenMM = ''
      this.wedOpenMead = 'am'
      this.wedCloseHH = ''
      this.wedCloseMM = ''
      this.wedCloseMead = 'am'
    }
    else if (id == 'thursdayTime') {
      this.thurOpenHH = ''
      this.thurOpenMM = ''
      this.thurOpenMead = 'am'
      this.thurCloseHH = ''
      this.thurCloseMM = ''
      this.thurCloseMead = 'am'
    }
    else if (id == "fridayTime") {
      this.friOpenHH = ''
      this.friOpenMM = ''
      this.friOpenMead = 'am'
      this.friCloseHH = ''
      this.friCloseMM = ''
      this.friCloseMead = 'am'
    }
    else if (id == 'saturdayTime') {
      this.satOpenHH = ''
      this.satOpenMM = ''
      this.satOpenMead = 'am'
      this.satCloseHH = ''
      this.satCloseMM = ''
      this.satCloseMead = 'am'
    }
    else if (id == 'sundayTime') {
      this.sunOpenHH = ''
      this.sunOpenMM = ''
      this.sunOpenMead = 'am'
      this.sunCloseHH = ''
      this.sunCloseMM = ''
      this.sunCloseMead = 'am'
    }
  }
  timeInputFunc(day, e) {

    if (e.checked) {
      if (day == 'mondayTime') {
        this.mondayClearCondition = true
        this.monPrecheck = true
      }
      else if (day == 'tuesdayTime') {
        this.tuesdayClearCondition = true
        this.tuePrecheck = true
      }
      else if (day == 'wednesTime') {
        this.wednesdayClearCondition = true
        this.wedPrecheck = true
      }
      else if (day == 'thursdayTime') {
        this.tursdayClearCondition = true
        this.thurPrecheck = true
      }
      else if (day == 'fridayTime') {
        this.fridayClearCondition = true
        this.friPrecheck = true
      }
      else if (day == 'saturdayTime') {
        this.saturdayClearCondition = true
        this.satPrecheck = true
      }
      else if (day == 'sundayTime') {
        this.sundayClearCondition = true
        this.sunPrecheck = true
      }
    }
    else {
      if (day == 'mondayTime') {
        this.timeClear(day)
        this.mondayClearCondition = false
        this.monPrecheck = false
      }
      else if (day == 'tuesdayTime') {
        this.timeClear(day)
        this.tuesdayClearCondition = false
        this.tuePrecheck = false
      }
      else if (day == 'wednesTime') {
        this.timeClear(day)
        this.wednesdayClearCondition = false
        this.wedPrecheck = false
      }
      else if (day == 'thursdayTime') {
        this.timeClear(day)
        this.tursdayClearCondition = false
        this.thurPrecheck = false
      }
      else if (day == 'fridayTime') {
        this.timeClear(day)
        this.fridayClearCondition = false
        this.friPrecheck = false
      }
      else if (day == 'saturdayTime') {
        this.timeClear(day)
        this.saturdayClearCondition = false
        this.satPrecheck = false
      }
      else if (day == 'sundayTime') {
        this.timeClear(day)
        this.sundayClearCondition = false
        this.sunPrecheck = false
      }
    }
    // console.log(this.tuePrecheck, this.monOpenHH, this.monOpenMM, this.monCloseHH, this.monCloseMM)
  }
  onMaterialGroupChange(event) {
    // console.log(event);
  }
  getData() {
    let temp
    this.httpSv.getAllD2Dieatry().subscribe((res) => {
      if (res['status'] == 'TRUE') {
        temp = res['result'].data
        this.allDieatary = temp
      }
    })
    return (this.allDieatary = [
      { id: 1, name: 'Undefine' }
    ]);
  }
  getAllergens() {
    let temp
    this.httpSv.getAllD2DAllergen().subscribe((res) => {
      if (res['status'] == 'TRUE') {
        temp = res['result'].data
        this.allAllergens = temp
      }
    })
    return (this.allAllergens = [
      { id: 1, name: 'Undefine' }
    ]);
  }
  getCategory() {
    let temp
    this.httpSv.getAllD2Category().subscribe((res) => {
      if (res['status'] == 'TRUE') {
        temp = res['result'].data
        this.allCaategory = temp
      }
    })
    return (this.allCaategory = [
      { id: 1, name: 'Undefine' }
    ]);
  }
  getCuisine() {
    let temp
    this.httpSv.getAllD2Cuisine().subscribe((res) => {
      if (res['status'] == 'TRUE') {
        temp = res['result'].data
        this.allCuisine = temp
      }
    })
    return (this.allCuisine = [
      { id: 1, name: 'Undefine' }
    ]);
  }
  selectAllForDropdownItems(items: any[]) {
    let allSelect = (items) => {
      items.forEach((element) => {
        element['id'] = 'selectedAllGroup';
      });
    };

    allSelect(items);
  }
  onFeatureImgChange(event, id) {
    const fsize = event.target.files[0].size;
    const fileSize = (fsize / 1024);
    if (fileSize > 500) {
      this._snackBar.open(`Image can't be uploaded, as the size is bigger than 500 kb`)
      setTimeout(() => { this._snackBar.dismiss() }, 3000)
      document.getElementById(id)['value'] = ''
      // alert(`Sorry this is can't be uploaded .The image size is greater than 500kb`)
      return
    }
    this.featureImgToBeAppend = event.target.files[0]
    let file: File = event.target.files[0];
    let reader: FileReader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (e: any) => {
      this.featureSrc = e.target.result;
      document.getElementById(id)['value'] = ''
    };
  }
  offerHandelFunc(day, e) {
    if (e.checked) {
      if (day == 'mon') {
        this.offerMonday = true
      }
      else if (day == 'tue') {
        this.offerTuesday = true
      }
      else if (day == 'wed') {
        this.offerWednesday = true
      }
      else if (day == 'thu') {
        this.offerTurusday = true
      }
      else if (day == 'fri') {
        this.offerFriday = true
      }
      else if (day == 'sat') {
        this.offerSaturday = true
      }
      else if (day == 'sun') {
        this.offerSunday = true
      }
    }
    else {
      if (day == 'mon') {
        this.offerMonday = false
      }
      else if (day == 'tue') {
        this.offerTuesday = false
      }
      else if (day == 'wed') {
        this.offerWednesday = false
      }
      else if (day == 'thu') {
        this.offerTurusday = false
      }
      else if (day == 'fri') {
        this.offerFriday = false
      }
      else if (day == 'sat') {
        this.offerSaturday = false
      }
      else if (day == 'sun') {
        this.offerSunday = false
      }

    }
  }
  preRadioSelect(option) {
    if (option == this.queAns) return true
    else false
  }
  menuImgDelete(index, src) {
    if (src.src.includes('base64')) {
      let reqIndex = this.menuImgToBeAppend.findIndex(ele => ele.name == src.name)
      this.menuSrc.splice(index, 1)
      this.menuImgToBeAppend.splice(reqIndex, 1)
    }
    else {
      this.menuSrc.splice(index, 1)
    }
  }
  onMenuChange(event, id) {
    const fsize = event.target.files[0].size;
    const fileSize = (fsize / 1024);
    if (fileSize > 500) {
      this._snackBar.open(`Image can't be uploaded, as the size is bigger than 500 kb`)
      setTimeout(() => { this._snackBar.dismiss() }, 3000)
      document.getElementById(id)['value'] = ''
      // alert(`Sorry this is can't be uploaded .The image size is greater than 500kb`)
      return
    }
    this.menuLinkCondition = false
    let reader: FileReader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (e: any) => {
      let temp = event.target.files[0].name.split('.')
      if (temp[temp.length - 1] != 'pdf') {
        this.menuImgToBeAppend.push(event.target.files[0])
        this.menuPdfToBeAppend = null
        this.menuSrc.push({ src: e.target.result, name: event.target.files[0].name })
        document.getElementById(id)['value'] = ''
      }
      else {
        this.pdfUploadCheckFunc(event, id)
      }
    }
  }
  pdfUploadCheckFunc(data, id) {
    if (this.menuSrc.length != 0) {
      let con = confirm('Are you sure to upload the pdf , this will delete the images')
      if (con) {
        this.menuSrc = []
        this.menuImgToBeAppend = []
        this.onMenuPdfChange(data, id)

      }
      else {
        document.getElementById(id)['value'] = ''
      }
    }
    else {
      this.onMenuPdfChange(data, id)
    }
  }
  onMenuPdfChange(event, id) {
    this.menuPdfToBeAppend = event.target.files[0]
    this.pdfMenuSrc = event.target.files[0].name
    let reader: FileReader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (e: any) => {
      this.pdfRedirctVar = e.target.result
      document.getElementById(id)['value'] = ''
      this.menuSrc = []
      this.menuImgToBeAppend = []
    };

  }
  openpdf() {
    window.open(this.pdfRedirctVar)
  }
  pdfDelete() {
    if (this.menuImgToBeAppend) {
      this.pdfMenuSrc = 'null'
      this.menuPdfToBeAppend = null
      this.pdfRedirctVar = false
    }
  }
  delverooCon = false
  justEatCon = false
  uberEatsCon = false
  foodstuffCon = false
  delverooVal
  justEatVal
  uberEatsVal
  foodstuffVal
  delevryHandelFunc(name, event) {
    if (event.checked) {
      if (name == 'deliveroo') this.delverooCon = true
      else if (name == 'justEat') this.justEatCon = true
      else if (name == 'uberEats') this.uberEatsCon = true
      else if (name == 'foodstuff') this.foodstuffCon = true
    }
    else {
      if (name == 'deliveroo') this.delverooCon = false
      else if (name == 'justEat') this.justEatCon = false
      else if (name == 'uberEats') this.uberEatsCon = false
      else if (name == 'foodstuff') this.foodstuffCon = false
    }
  }
  instagramCon = false
  facebookCon = false
  googleMapCon = false
  instagramVal
  facebookVal
  googleMapVal
  socialLinkHandelFunc(name, event) {
    if (event.checked) {
      if (name == 'facebook') this.facebookCon = true
      else if (name == 'instagram') this.instagramCon = true
      else if (name == 'googleMap') this.googleMapCon = true
    }
    else {
      if (name == 'facebook') this.facebookCon = false
      else if (name == 'instagram') this.instagramCon = false
      else if (name == 'googleMap') this.googleMapCon = false
    }
  }
  openMenuUrlLink(url) {
    window.open(url)
  }
  menuLinkInsert() {
    this.menuLinkCondition = true
  }
  statusHandleFunc(event, id) {
    if (event.checked) {
      let data = {
        "restaurant_id": id,
        "restaurant_status": "Active"
      }
      this.httpSv.activateRestaurant(data).subscribe(res => {
        if (res['status'] == 'TRUE') {
          this._snackBar.open('Restaurant is active now!!')
          this.getRestaurants()
          setTimeout(() => {
            this._snackBar.dismiss()
          }, 2000)
        } else {
          this._snackBar.open(res['message'])
          setTimeout(() => {
            this._snackBar.dismiss()
          }, 2000)
        }
      }, err => {
        this._snackBar.open('Oops!! Something went wrong')
        setTimeout(() => {
          this._snackBar.dismiss()
        }, 2000)
      })
    }
    else {
      let data = {
        "restaurant_id": id,
        "restaurant_status": "InActive"
      }
      this.httpSv.activateRestaurant(data).subscribe(res => {
        if (res['status'] == 'TRUE') {
          this._snackBar.open('Restaurant is inactive now!!')
          this.getRestaurants()
          setTimeout(() => {
            this._snackBar.dismiss()
          }, 2000)
        } else {
          this._snackBar.open(res['message'])
          setTimeout(() => {
            this._snackBar.dismiss()
          }, 2000)
        }
      }, err => {
        this._snackBar.open('Oops!! Something went wrong')
        setTimeout(() => {
          this._snackBar.dismiss()
        }, 2000)
      })
    }
  }
  onNewFeatureImgChange(event, id) {
    const fsize = event.target.files[0].size;
    const fileSize = (fsize / 1024);
    if (fileSize > 500) {
      this._snackBar.open(`Image can't be uploaded, as the size is bigger than 500 kb`)
      setTimeout(() => { this._snackBar.dismiss() }, 3000)
      document.getElementById(id)['value'] = ''
      // alert(`Sorry this is can't be uploaded .The image size is greater than 500kb`)
      return
    }
    this.newFeatureImgToBeAppend = event.target.files[0]
    let file: File = event.target.files[0];
    let reader: FileReader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (e: any) => {
      this.newFeatureSrc = e.target.result;
      document.getElementById(id)['value'] = ''
    };
  }
  validate(event) {
    let k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k >= 48 && k <= 57));
  }
  validateNum(event) {
    let k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k >= 48 && k <= 57) || k == 43 || k == 32);
  }


  sendEmail(data: any) {
    const payload = {
      id: data.restaurant_id,
      email: data.restaurant_email,
      name: data.restaurant_name,
      address: data.restaurant_address,
      logo: data.logo,
    }

    this.httpSv.sendRemiderEmail(payload).subscribe(res => {
      if (res['status'] == 'TRUE') {
        this._snackBar.open('Email sent successfully');
        setTimeout(() => {
          this._snackBar.dismiss();
        }, 2000);
      } else {
        this._snackBar.open(res['message']);
        setTimeout(() => {
          this._snackBar.dismiss();
        }, 2000);
      }
    }, err => {
      this._snackBar.open('Oops!! Something went wrong');
      setTimeout(() => {
        this._snackBar.dismiss();
      }, 2000);
      console.log(err);
    })
  }




}

@Component({
  selector: "restaurant-delete-popup",
  templateUrl: "./restaurantDeletePopup.html",
})
export class restaurantDeletePopup {
  constructor() { }
  ngOnInit(): void { }
}



@Component({
  selector: "restaurant-master-add-popup",
  templateUrl: "./master_resto_add_dialog.html",
})
export class restaurantMasterAddPopup {
  constructor(
    public dialogRef: MatDialogRef<restaurantMasterAddPopup>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private httpSv: HttpService,
    private toaster: ToastrService
  ) { }
  ngOnInit(): void {
    if (this.data.isEdit) {
      this.restoName = this.data.info.master_resto_name
      this.restoEmail = this.data.info.email
      this.restoPhone = this.data.info.number
    }
    this.allRestaurants = this.data.restaurantList;
    this.filteredLeftList = [...this.allRestaurants];
    // this.selectedRestaurants = this.data.selectedRestaurants;
    this.data.selectedRestaurants.forEach(ele => {
      console.log(ele);
      this.addToSelected(
        this.filteredLeftList[this.filteredLeftList.findIndex(r => r.restaurant_id === ele)]
      )
    });;
    // this.filteredRightList = [...this.selectedRestaurants];
  }

  restoName: any
  restoEmail: any
  restoPhone: any
  password: any



  close(flag: boolean) {
    this.dialogRef.close(flag)
  }




  allRestaurants = [];

  selectedRestaurants: any[] = [];

  leftSearch = '';
  rightSearch = '';

  filteredLeftList = [...this.allRestaurants];
  filteredRightList = [...this.selectedRestaurants];

  filterLeftList() {
    const searchText = this.leftSearch.toLowerCase();
    this.filteredLeftList = this.allRestaurants.filter(
      r => r.restaurant_name.toLowerCase().includes(searchText) &&
        !this.selectedRestaurants.find(sel => sel.restaurant_id === r.restaurant_id)
    );
  }

  filterRightList() {
    const searchText = this.rightSearch.toLowerCase();
    this.filteredRightList = this.selectedRestaurants.filter(
      r => r.restaurant_name.toLowerCase().includes(searchText)
    );
  }

  addToSelected(restaurant: any) {
    if (!this.selectedRestaurants.find(r => r.restaurant_id === restaurant.restaurant_id)) {
      this.selectedRestaurants.push(restaurant);
      this.filterLeftList();
      this.filterRightList();
    }
  }

  removeFromSelected(restaurant: any) {
    this.selectedRestaurants = this.selectedRestaurants.filter(r => r.restaurant_id !== restaurant.restaurant_id);
    this.filterLeftList();
    this.filterRightList();
  }

  isSelected(restaurant: any): boolean {
    return !!this.selectedRestaurants.find(r => r.restaurant_id === restaurant.restaurant_id);
  }


  validateForm(): boolean {
    const nameRegex = /^[A-Za-z\s]{2,50}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const ukMobileRegex = /^(?:\+44|0)7\d{9}$/;
    const passwordRegex = /^(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/;

    if (!this.restoName || !nameRegex.test(this.restoName)) {
      this.toaster.info('Please enter a valid restaurant name (letters only, 2–50 characters).', '', { timeOut: 2000 });
      return false;
    }

    if (!this.restoEmail || !emailRegex.test(this.restoEmail)) {
      this.toaster.info('Please enter a valid email address.', '', { timeOut: 2000 });
      return false;
    }

    if (!this.restoPhone || !ukMobileRegex.test(this.restoPhone)) {
      this.toaster.info('Please enter a valid UK mobile number (e.g., +447911123456 or 07911123456).', '', { timeOut: 2000 });
      return false;
    }

    if (!this.password || !passwordRegex.test(this.password)) {
      if ((!this.password || this.password == '') && this.data.isEdit) {

      } else {
        this.toaster.info('Password must be at least 8 characters, include one uppercase letter and one number.', '', { timeOut: 2000 });
        return false;
      }
    }

    return true;
  }




  dataFunc() {
    if (this.validateForm()) {
      let data = {
        name: this.restoName,
        email: this.restoEmail,
        restaurant_phone: this.restoPhone,
        restaurant_id: this.selectedRestaurants.map(r => r.restaurant_id).join(','),
      }

      if (!this.data.isEdit) {
        data['password'] = this.password;
        this.httpSv.addMasterRestaurant(data).subscribe(res => {
          if (res['status'] == 'TRUE') {
            this.toaster.success('Restaurant added successfully', '', { timeOut: 2000 });
            this.dialogRef.close(true);

          } else {
            this.toaster.error(res['message'], '', { timeOut: 2000 });
            this.dialogRef.close(false);

          }
        }, err => {
          this.toaster.error('Emial already exist', '', { timeOut: 2000 });
          console.log(err);
        })
      }
      else {
        if (this.password || this.password != '') {
          data['password'] = this.password;
        }
        data['master_resto_id'] = this.data.info.id
        this.httpSv.updateMasterRestaurant(data).subscribe(res => {
          if (res['status'] == 'TRUE') {
            this.toaster.success('Restaurant updated successfully', '', { timeOut: 2000 });
            this.dialogRef.close(true);

          } else {
            this.toaster.error(res['message'], '', { timeOut: 2000 });
            this.dialogRef.close(false);

          }
        }, err => {
          this.toaster.error('Emial already exist', '', { timeOut: 2000 });
          console.log(err);
        })
      }
    }
  }


}
